import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  Form,
  Alert,
  FormLabel,
  Navbar,
  Nav,
  Container,
  Slide,
} from "@mui/material";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function Progress(props) {
  const { submitted, refreshPage } = props;

  const delay = 3;

  const [show, setShow] = useState(false);

  useEffect(() => {
    let timer1 = setTimeout(() => setShow(true), delay * 1000);
    return () => {
      clearTimeout(timer1);
    };
  }, []);
  return show ? (
    refreshPage()
  ) : (
    <React.Fragment>
      <style>
        {`
.lds-spinner {
  color: #1171ef;
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
  top: 50%;
  left: 45%; 
}
.lds-spinner div {
  transform-origin: 40px 40px;
  animation: lds-spinner 1.2s linear infinite;
}
.lds-spinner div:after {
  content: " ";
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 6px;
  height: 18px;
  border-radius: 20%;
  background: #1171ef;
}
.lds-spinner div:nth-child(1) {
  transform: rotate(0deg);
  animation-delay: -1.1s;
}
.lds-spinner div:nth-child(2) {
  transform: rotate(30deg);
  animation-delay: -1s;
}
.lds-spinner div:nth-child(3) {
  transform: rotate(60deg);
  animation-delay: -0.9s;
}
.lds-spinner div:nth-child(4) {
  transform: rotate(90deg);
  animation-delay: -0.8s;
}
.lds-spinner div:nth-child(5) {
  transform: rotate(120deg);
  animation-delay: -0.7s;
}
.lds-spinner div:nth-child(6) {
  transform: rotate(150deg);
  animation-delay: -0.6s;
}
.lds-spinner div:nth-child(7) {
  transform: rotate(180deg);
  animation-delay: -0.5s;
}
.lds-spinner div:nth-child(8) {
  transform: rotate(210deg);
  animation-delay: -0.4s;
}
.lds-spinner div:nth-child(9) {
  transform: rotate(240deg);
  animation-delay: -0.3s;
}
.lds-spinner div:nth-child(10) {
  transform: rotate(270deg);
  animation-delay: -0.2s;
}
.lds-spinner div:nth-child(11) {
  transform: rotate(300deg);
  animation-delay: -0.1s;
}
.lds-spinner div:nth-child(12) {
  transform: rotate(330deg);
  animation-delay: 0s;
}
@keyframes lds-spinner {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}        
    `}
      </style>
      <div class="lds-spinner">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>

      <p style={{ textAlign: "center" }}>
        Creating and Checking the connectivity ...
      </p>
    </React.Fragment>
  );
}

function CreateTemp(props) {
  const { toggleButton, focusAfterCloseButton, openButton } = props;

  const [subnav, setSubnav] = useState(false);
  const showSubnav = () => setSubnav(!subnav);

  const [temporary, settemporary] = useState([]);
  const [find, setfind] = useState(false);

  const [selectedValue, setSelectedValue] = React.useState({
    ipaddress: true,
    domainname: true,
  });

  const [platform, setplatform] = React.useState([[]]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/generics/platform/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((resp) => setplatform(resp))
      .catch((error) => {
        console.error(error);
      });
  }, []);

  console.log(platform);
  const [templist, settemplist] = React.useState([[]]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/templateslist`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((resp) => settemplist(resp))
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const [state, setState] = useState({
    name: "",
    os_type: "",
    submitted: false,
    newsubmitCheck: false,
    errorMessage: "",
  });
  window.sessionStorage.setItem("platform", state.os_type);

  const handleChange = (e) => {
    setfind(false);
    const { id, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      [id]: value,
    }));
    settemporary((prevState) => ({
      ...prevState,
      [id]: value,
    }));
    const checklab = templist.map((temp) => {
      if (temp.name === value) {
        setfind(true);
      }
    });
  };

  const handleSubmitClick = (e) => {
    e.preventDefault();
    window.location.href = "/admin/audittemplate";
    window.sessionStorage.setItem("platform", state.os_type);
    const temp = {
      name: state.name,
      os_type: state.os_type,
      selected_audits: "",
    };
    fetch(`${process.env.REACT_APP_API_URL}/api/templates/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("token"),
      },
      body: JSON.stringify(temp),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.name) {
          window.location.reload();
        } else {
          if (data.username) {
            setState({ errorMessage: data.name[0] });
          }
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  function refreshPage() {
    window.location.reload();
  }

  const [visible, setVisible] = useState(true);

  const onDismiss = () => setVisible(false);
  const [open, setOpen] = useState(false);
  const [focusAfterClose] = useState(true);
  const toggle = () => setOpen(!open);
  const isValidDomain = require("is-valid-domain");

  return (
    <>
      <button
        className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
        type="button"
        onClick={toggle}
      >
        Add Profile
      </button>
      <Dialog
        PaperProps={{
          sx: {
            width: "80%",
          },
        }}
        open={open}
        TransitionComponent={Transition}
        keepMounted
        aria-describedby="alert-dialog-slide-description"
      >
        {state.submitted ? (
          <Progress submitted={state.submitted} refreshPage={refreshPage} />
        ) : (
          <>
            <div className="head" style={{ height: "80px" }}>
              <h2
                style={{
                  textAlign: "center",
                  fontSize: "18px",
                  fontWeight: "810",
                  color: "rgb(48, 68, 115)",
                  fontFamily: "sans-serif",
                  lineHeight: "4.5rem",
                }}
              >
                CREATE PROFILE
              </h2>
            </div>
            <DialogContent>
              <div>
                {state.errorMessage && (
                  <Alert color="danger" isOpen={visible} toggle={onDismiss}>
                    {" "}
                    {state.errorMessage}{" "}
                  </Alert>
                )}
              </div>
              <form>
                <FormLabel htmlFor="hostname">Profile Name</FormLabel>
                <TextField
                  fullWidth
                  helperText={
                    find
                      ? "Profile name already exists, Please enter the unique name"
                      : "Please specify the name"
                  }
                  id="name"
                  name="name"
                  color={temporary.name && !find ? "success" : ""}
                  error={find}
                  onChange={handleChange}
                  required
                  variant="outlined"
                  size="small"
                />
                <br />
                <br />
                <FormLabel htmlFor="os_type">OS Type</FormLabel>
                <TextField
                  fullWidth
                  name="os_type"
                  id="os_type"
                  onChange={handleChange}
                  value={state.os_type}
                  variant="outlined"
                  size="small"
                  select
                  SelectProps={{ native: true }}
                  required
                >
                  {" "}
                  <option>-- Select OS_Type --</option>
                  {platform.map((platform) => {
                    return (
                      <React.Fragment>
                        <option value={platform.platform_name}>
                          {platform.platform_name}
                        </option>
                      </React.Fragment>
                    );
                  })}
                </TextField>
              </form>
            </DialogContent>

            <DialogActions>
              <button
                className="bg-blueGray-100 text-black font-bold active:bg-blueGray-600 uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                onClick={refreshPage}
              >
                Cancel
              </button>
              <button
                className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                type="submit"
                onClick={handleSubmitClick}
                disabled={state.name && state.os_type ? false : true}
              >
                Create&nbsp;
              </button>
            </DialogActions>
          </>
        )}
      </Dialog>
    </>
  );
}
export default CreateTemp;